import NBType, { InferType } from '@netbase/nb-type'
import AnnotationDisplayMode from '../enums/AnnotationDisplayMode'
import CVLogoSchema from './CVLogoSchema'
import LogoTypeInfoSchema from './LogoTypeInfoSchema'
import Sharing from '../enums/Sharing'
import ThemeStatusSchema from './ThemeStatusSchema'
import TimeInterval from '../enums/TimeInterval'
import UserProfileInfoSchema from './UserProfileInfoSchema'

const ThemeInfoSchema = NBType.object().shape('ThemeInfoSchema', {
  /* @prop */
  annotations: NBType.enum(AnnotationDisplayMode),
  /* @prop */
  booleanThemeCvLogos: NBType.array().of(LogoTypeInfoSchema),
  /* @prop */
  createdDate: NBType.timestamp().nullable(),
  /* @prop */
  cvLogos: NBType.array().of(CVLogoSchema),
  /* @prop */
  description: NBType.string(),
  /* @prop */
  editedDate: NBType.timestamp().nullable(),
  /* @prop */
  excludedUserTags: NBType.array().of(NBType.array().of(NBType.string())),
  /* @prop */
  includedUserTags: NBType.array().of(NBType.array().of(NBType.string())),
  /* @prop */
  name: NBType.string(),
  /* @prop */
  owner: UserProfileInfoSchema,
  /* @prop */
  sharing: NBType.enum(Sharing),
  /* @prop */
  status: ThemeStatusSchema,
  /* @prop */
  tags: NBType.array().of(NBType.string()),
  /* @prop */
  themeId: NBType.number(),
  /* @prop */
  timeInterval: NBType.enum(TimeInterval),
  /* @prop */
  userProfileId: NBType.number(),
  /* @prop */
  weighting: NBType.number()
  /* END */
})
export default ThemeInfoSchema
export type ThemeInfo = InferType<typeof ThemeInfoSchema>
// RESERVE BELOW
